<div class="offline-overlay" *ngIf="isOffline" [@overlayAnimation]>
  <div class="offline-overlay__backdrop"></div>

  <div class="offline-overlay__modal" [@modalAnimation]>
    <div class="offline-header">
      <div class="offline-header__icon-wrapper">
        <div class="offline-header__pulse-ring"></div>
        <div class="offline-header__icon">
          <svg
            width="32"
            height="32"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line x1="1" y1="1" x2="23" y2="23"></line>
            <path d="M16.72 11.06A10.94 10.94 0 0 1 19 12.55"></path>
            <path d="M5 12.55a10.94 10.94 0 0 1 5.17-2.39"></path>
            <path d="M10.71 5.05A16 16 0 0 1 22.56 9"></path>
            <path d="M1.42 9a15.91 15.91 0 0 1 4.7-2.88"></path>
            <path d="M8.53 16.11a6 6 0 0 1 6.95 0"></path>
            <line x1="12" y1="20" x2="12.01" y2="20"></line>
          </svg>
        </div>
      </div>
      <h2 class="offline-header__title">Conexión perdida</h2>
      <p class="offline-header__subtitle">
        El sistema se ha desconectado de la red. Todas las operaciones están
        pausadas hasta que se restablezca la conexión.
      </p>
      <div class="offline-header__status">
        <span class="offline-header__status-dot"></span>
        <span>Intentando reconectar...</span>
      </div>
    </div>

    <div class="offline-game" *ngIf="!showGame">
      <button class="btn-play-game" (click)="startGame()">
        <span class="btn-play-game__icon">⚽</span>
        <span class="btn-play-game__text">Jugar Penaltis</span>
        <span class="btn-play-game__hint">Mientras esperas la reconexión</span>
      </button>
    </div>

    <div class="penalty-game" *ngIf="showGame">
      <div class="penalty-game__stats">
        <div class="stat-item">
          <span class="stat-item__value">{{ stats.goals }}</span>
          <span class="stat-item__label">Goles</span>
        </div>
        <div class="stat-item stat-item--accent">
          <span class="stat-item__value">{{ stats.shots }}</span>
          <span class="stat-item__label">Tiros</span>
        </div>
        <div class="stat-item">
          <span class="stat-item__value">{{ accuracyPercentage }}%</span>
          <span class="stat-item__label">Precisión</span>
        </div>
        <div
          class="stat-item stat-item--streak"
          *ngIf="stats.streak >= STREAK.SHOW_STREAK_BADGE_MIN"
        >
          <span class="stat-item__value">🔥 {{ stats.streak }}</span>
          <span class="stat-item__label">Racha</span>
        </div>
      </div>

      <div class="penalty-game__field">
        <div class="goal-frame">
          <div class="goal-frame__post goal-frame__post--left"></div>
          <div class="goal-frame__crossbar"></div>
          <div class="goal-frame__post goal-frame__post--right"></div>
          <div class="goal-frame__net"></div>

          <div
            class="goal-zones"
            *ngIf="
              gameState === GAME_STATE.IDLE || gameState === GAME_STATE.AIMING
            "
          >
            <button
              *ngFor="let zone of shootZones; trackBy: trackByZone"
              class="goal-zone"
              [class.goal-zone--selected]="selectedZone === zone"
              [class.goal-zone--top]="zone.startsWith('top')"
              [class.goal-zone--bottom]="zone.startsWith('bottom')"
              [attr.data-zone]="zone"
              (click)="selectZone(zone)"
              [disabled]="
                gameState === GAME_STATE.AIMING && selectedZone !== zone
              "
            >
              <span class="goal-zone__arrow">{{ zoneLabels[zone] }}</span>
            </button>
          </div>

          <div
            class="goalkeeper"
            [class.goalkeeper--diving]="
              gameState === GAME_STATE.SHOOTING ||
              gameState === GAME_STATE.GOAL ||
              gameState === GAME_STATE.SAVED
            "
            [attr.data-dive]="goalkeeperZone"
          >
            <div class="goalkeeper__body">
              <div class="goalkeeper__head"></div>
              <div class="goalkeeper__torso"></div>
              <div class="goalkeeper__arm goalkeeper__arm--left"></div>
              <div class="goalkeeper__arm goalkeeper__arm--right"></div>
              <div class="goalkeeper__leg goalkeeper__leg--left"></div>
              <div class="goalkeeper__leg goalkeeper__leg--right"></div>
            </div>
          </div>

          <div
            class="goal-result"
            *ngIf="
              gameState === GAME_STATE.GOAL || gameState === GAME_STATE.SAVED
            "
            [@goalCelebration]
          >
            <span class="goal-result__icon">{{ resultIcon }}</span>
            <span
              class="goal-result__text"
              [class.goal-result__text--goal]="gameState === GAME_STATE.GOAL"
            >
              {{ resultMessage }}
            </span>
          </div>
        </div>

        <div
          class="penalty-ball"
          [class.penalty-ball--shooting]="
            gameState === GAME_STATE.SHOOTING ||
            gameState === GAME_STATE.GOAL ||
            gameState === GAME_STATE.SAVED
          "
          [ngStyle]="ballStyle"
        >
          ⚽
        </div>
      </div>

      <div class="power-bar-container" *ngIf="gameState === GAME_STATE.AIMING">
        <span class="power-bar-container__label">POTENCIA</span>
        <div class="power-bar">
          <div class="power-bar__track">
            <div
              class="power-bar__fill"
              [style.width.%]="powerLevel"
              [style.backgroundColor]="powerBarColor"
            ></div>
            <div class="power-bar__sweet-spot"></div>
          </div>
          <span class="power-bar__value"
            >{{ powerLevel | number: "1.0-0" }}%</span
          >
        </div>
        <button class="btn-shoot" (click)="confirmShot()">
          ¡DISPARAR!
          <span class="btn-shoot__hint">(o pulsa Espacio)</span>
        </button>
      </div>

      <div class="penalty-game__instructions" *ngIf="gameState === GAME_STATE.IDLE">
        <p>👆 Selecciona una zona del arco para apuntar</p>
      </div>
    </div>

    <div class="offline-footer" *ngIf="showGame && stats.bestStreak > 0">
      <span class="offline-footer__record"
        >🏆 Mejor racha: {{ stats.bestStreak }} goles seguidos</span
      >
    </div>
  </div>
</div>

<div class="reconnected-toast" *ngIf="reconnecting" [@overlayAnimation]>
  <div class="reconnected-toast__content">
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
      <polyline points="22 4 12 14.01 9 11.01"></polyline>
    </svg>
    <span>¡Conexión restablecida!</span>
  </div>
</div>
